import { ILocation } from '../../types';
import { PhoneIcon } from '../../icons';
import styles from './styles.module.scss';
import { useId } from 'react';

interface ILocationsProps {
  locations: ILocation[];
}

export const Locations = ({ locations }: ILocationsProps) => {
  const id = useId();

  if (locations?.length === 0) {
    return (
      <div>
        <br />
        <p>No Dealers found in area</p>
      </div>
    );
  }

  return (
    <ul className={styles.locations}>
      {locations.map((location) => (
        <li key={location.title + id} className={styles.locationsItem}>
          {location.imageUrl ? (
            <img src={location.imageUrl} alt={location.title} />
          ) : (
            <span className={styles.locationsItemFallBack} />
          )}

          <div className={styles.locationsItemContent}>
            <h2>{location.title}</h2>
            <p>
              <PhoneIcon width={18} height={18} />
              <a href={`tel:${location.phoneNumber}`} rel="noreferrer">
                {location.phoneNumber}
              </a>
            </p>
          </div>

          {location.websiteUrl && (
            <a
              target="_blank"
              href={location.websiteUrl}
              rel="noreferrer"
              className={styles.websiteLink}>
              Visit Website
            </a>
          )}
        </li>
      ))}
    </ul>
  );
};
